export default __webpack_public_path__ + "static/media/blob.left-sm.86527861.png";